import { RequestTypeEnum } from "../helpers/Enums";
import RequestReferenceTypeModel from "../models/RequestReferenceTypeModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface IDispositionTypeService {
    GetCurrent(requestTypeId: RequestTypeEnum): Promise<RequestReferenceTypeModel[]>;
}

export class DispositionTypeService implements IDispositionTypeService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetCurrent(requestTypeId: RequestTypeEnum): Promise<RequestReferenceTypeModel[]> {
        try {
            const { data } = await this.httpRequestService.Get<RequestReferenceTypeModel[]>(`/api/v1/DispositionType/${requestTypeId}`);
            return data as RequestReferenceTypeModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }
}
